// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-wrapper {
  padding: 10px 0px 20px;
  font-family: "Nunito", sans-serif;
  color: #1a202c;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 2px;
}

.dashboard-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.export-outline-btn {
  background-color: #ffffff;
  color: #2f3299;
  border: 1px solid #2f3299;
  font-weight: 700;
  font-size: 14px;
  padding: 6px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
}

.export-outline-btn:hover {
  background-color: #f4f5fd;
  transform: translateY(-1px);
}

/* Premium Dashboard Metrics Grid Layout */
.dashboard-metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.4fr;
  gap: 20px;
}

@media (max-width: 1200px) {
  .dashboard-metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .dashboard-metrics-grid {
    grid-template-columns: 1fr;
  }
}

/* Bottom Charts Grid Layout */
.dashboard-charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

@media (max-width: 950px) {
  .dashboard-charts-grid {
    grid-template-columns: 1fr;
  }
}

/* Reusable Shared Custom Glassmorphism Premium Tooltips for Recharts Graphs */
.custom-tooltip-premium {
  background: rgba(15, 23, 42, 0.95) !important;
  backdrop-filter: blur(8px) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  padding: 12px 16px !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25) !important;
  color: #f8fafc !important;
  font-family: "Nunito", sans-serif !important;
  pointer-events: none;
}

.custom-tooltip-premium .label {
  font-size: 10px !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  color: #94a3b8 !important;
  margin: 0 0 8px 0 !important;
  font-weight: 800 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  padding-bottom: 4px !important;
}

.custom-tooltip-premium .tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.custom-tooltip-premium .tooltip-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-tooltip-premium .tooltip-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
}

.custom-tooltip-premium .name {
  font-size: 12px !important;
  color: #cbd5e1 !important;
}

.custom-tooltip-premium .value {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
}

.year-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.year-filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
}

.year-select-wrapper {
  position: relative;
}

.year-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  min-width: 140px;
  height: 44px;
  padding: 0 42px 0 16px;

  border: 1px solid #e5e7eb;
  border-radius: 12px;

  background: #fff;
  color: #111827;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
}

.year-select:hover {
  border-color: #3a57e8;
  box-shadow: 0 6px 18px rgba(58, 87, 232, 0.12);
}

.year-select:focus {
  outline: none;
  border-color: #3a57e8;
  box-shadow: 0 0 0 4px rgba(58, 87, 232, 0.15);
}

.year-select-icon {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/DashboardComponent.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8EAA8E;AAC9E;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,sDAAsD;EACtD,6BAA6B;EAC7B,8BAA8B;EAC9B,sDAAsD;EACtD,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;;EAErB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;;EAEtB,yBAAyB;EACzB,mBAAmB;;EAEnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".dashboard-wrapper {\n  padding: 10px 0px 20px;\n  font-family: \"Nunito\", sans-serif;\n  color: #1a202c;\n}\n\n.dashboard-title {\n  font-size: 28px;\n  font-weight: 800;\n  color: #1e293b;\n  margin-bottom: 2px;\n}\n\n.dashboard-subtitle {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n}\n\n.export-outline-btn {\n  background-color: #ffffff;\n  color: #2f3299;\n  border: 1px solid #2f3299;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 6px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);\n}\n\n.export-outline-btn:hover {\n  background-color: #f4f5fd;\n  transform: translateY(-1px);\n}\n\n/* Premium Dashboard Metrics Grid Layout */\n.dashboard-metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1.4fr;\n  gap: 20px;\n}\n\n@media (max-width: 1200px) {\n  .dashboard-metrics-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .dashboard-metrics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Bottom Charts Grid Layout */\n.dashboard-charts-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n@media (max-width: 950px) {\n  .dashboard-charts-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Reusable Shared Custom Glassmorphism Premium Tooltips for Recharts Graphs */\n.custom-tooltip-premium {\n  background: rgba(15, 23, 42, 0.95) !important;\n  backdrop-filter: blur(8px) !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  padding: 12px 16px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25) !important;\n  color: #f8fafc !important;\n  font-family: \"Nunito\", sans-serif !important;\n  pointer-events: none;\n}\n\n.custom-tooltip-premium .label {\n  font-size: 10px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 1px !important;\n  color: #94a3b8 !important;\n  margin: 0 0 8px 0 !important;\n  font-weight: 800 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n  padding-bottom: 4px !important;\n}\n\n.custom-tooltip-premium .tooltip-items {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.custom-tooltip-premium .tooltip-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.custom-tooltip-premium .tooltip-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);\n}\n\n.custom-tooltip-premium .name {\n  font-size: 12px !important;\n  color: #cbd5e1 !important;\n}\n\n.custom-tooltip-premium .value {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: #ffffff !important;\n}\n\n.year-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.year-filter-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.year-select-wrapper {\n  position: relative;\n}\n\n.year-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  min-width: 140px;\n  height: 44px;\n  padding: 0 42px 0 16px;\n\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n\n  background: #fff;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n  transition: all 0.25s ease;\n}\n\n.year-select:hover {\n  border-color: #3a57e8;\n  box-shadow: 0 6px 18px rgba(58, 87, 232, 0.12);\n}\n\n.year-select:focus {\n  outline: none;\n  border-color: #3a57e8;\n  box-shadow: 0 0 0 4px rgba(58, 87, 232, 0.15);\n}\n\n.year-select-icon {\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
